import { render, staticRenderFns } from "./ModalDesempateManualAutomatico.vue?vue&type=template&id=64cec633"
import script from "./ModalDesempateManualAutomatico.vue?vue&type=script&lang=js"
export * from "./ModalDesempateManualAutomatico.vue?vue&type=script&lang=js"
import style0 from "./ModalDesempateManualAutomatico.vue?vue&type=style&index=0&id=64cec633&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports